import { getConfig, standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";
import { BrowserStorage } from "@jti/rest-api";
export const NAVIGATE_AFTER_REFRESH_FLAG = "moveBackToTrialProducts";
const storage = new BrowserStorage();
const STORAGE_ANONYMOUS_CART_KEY = "anonymousCartId";
const STORAGE_ANONYMOUS_CART_FREE_TRIAL_KEY = "anonymousFreeTrialCartId";
const FREE_TRIAL_REDIRECT = "freeTrialRedirect";
const getStorageName = (isFreeTrial, storeName) => {
    return !isFreeTrial ? storeName + "_" + STORAGE_ANONYMOUS_CART_KEY : STORAGE_ANONYMOUS_CART_FREE_TRIAL_KEY;
};
export const getAnonymousCartId = (storeName, isFreeTrial = false) => storage.get(getStorageName(isFreeTrial, storeName), undefined);
export const setAnonymousCartId = (cartId, storeName, isFreeTrial = false) => {
    storage.set(getStorageName(isFreeTrial, storeName), cartId);
};
export const deleteAnonymousCart = (storeName, isFreeTrial = false) => {
    storage.delete(getStorageName(isFreeTrial, storeName));
};
export const setFreeTrialRedirect = () => window.localStorage.setItem(FREE_TRIAL_REDIRECT, "true");
export const isFreeTrialRedirect = () => window.localStorage.getItem(FREE_TRIAL_REDIRECT) === "true";
export const clearFreeTrialRedirect = () => window.localStorage.removeItem(FREE_TRIAL_REDIRECT);
export const removeFreeTrialRefreshProtection = () => window.localStorage.removeItem(NAVIGATE_AFTER_REFRESH_FLAG);
export const redirectToCartPage = () => (window.location.href = getConfig().CART_CHECKOUT_PAGE_URL);
export const redirectToTrialCheckoutPage = () => {
    const { CART_CHECKOUT_PAGE_URL } = getConfig();
    window.location.href = `${CART_CHECKOUT_PAGE_URL}#${trialCheckoutRoutes.shipping}`;
};
export const redirectToAuthWithBack = () => {
    const { CART_CHECKOUT_PAGE_URL, AUTH_PAGE_URL } = getConfig();
    const authUrl = `${AUTH_PAGE_URL}#/login`;
    const checkoutPageURI = encodeURIComponent(`#${standardCheckoutRoutes.root}`);
    const redirectUrl = `${CART_CHECKOUT_PAGE_URL}${checkoutPageURI}`;
    return (window.location.href = `${authUrl}?returnUrl=${redirectUrl}`);
};
export const redirectToTrialAuthWithBack = () => {
    const { FREE_TRIAL_PAGE_URL, AUTH_PAGE_URL } = getConfig();
    return (window.location.href = `${AUTH_PAGE_URL}#/login?returnUrl=${FREE_TRIAL_PAGE_URL}`);
};
//# sourceMappingURL=cartHelpers.js.map